(function (d) {
	const toggle = d.querySelector('.toggle');
	const menu = d.querySelector('.menu');

	function toggleHeaderMenu(e) {
		e.preventDefault();

		menu.classList.toggle("menu_is-active");
		toggle.classList.toggle("toggle_is-active");
	}

	toggle.addEventListener('click', toggleHeaderMenu );

})(document);
